import { Component } from '@angular/core';
import { SharingDataService } from 'src/sharing-data.service';
import { ViewProductService } from './view-product.service';
import { AuthService } from 'src/AuthService';
import { Cart } from './cart.model';
import { Router } from '@angular/router';
@Component({
  selector: 'app-view-products',
  templateUrl: './view-products.component.html',
  styleUrls: ['./view-products.component.css']
})
export class ViewProductsComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }
  constructor(private sharingData: SharingDataService,private viewProductService : ViewProductService, private authService:AuthService,private router: Router) {}
  
  addToCartProducts: any[] = [];
  selectProduct:any=Object
  ngOnInit() {
    this.sharingData.currentValue.subscribe(val => {
      console.log('Received:', val);
      this.selectProduct=val;
      this.selectProduct.Quantity=1;
      // setTimeout(() =>{this.calculateDiscount()});
    });

  }

  cart:any;
customerId:any;

   addToCartItem: Cart={
       productDescription: '',
    productPrice: '',
     inStock: '',
     Gender : '',
    Category : '',
    productImage : '',
   Quantity : 0,
    productName:  '',
   CustomerId:0,
   size:'',
    cartStatus:'',
    discountedPrice:''

   };

    // calculateDiscount(){
    //   let originalPrice=  this.selectProduct.productPrice;
    //    this.discountedPrice = originalPrice - (originalPrice * 0.5);
    //    let quan=this.selectProduct.Quantity;
    //    console.log("Quantity in calculate discount",quan);
    //    this.discountedPrice=this.discountedPrice*quan;
    //    console.log("this.discountedPrice",this.discountedPrice);
    //    localStorage.setItem('discountedPrice', this.discountedPrice);
       
    // }
  //  cartItems: any =<Cart>{
  //     productDescription: '',
  //   productPrice: '',
  //   inStock: '',
  //   Gender : '',
  //   Category : '',
  //   productImage : '',
  //   Quantity : 0,
  //   productName:  '',
  //   CustomerId:0

  // };

  cartItems: Cart[] = [];
sendCartValue() {
  this.sharingData.getlocalStorageCart(this.cart);
}
//  addToCartApiCall(selectProduct:any){
//     if ('productId' in selectProduct) {
//     delete selectProduct.productId;
//   }
//   this.viewProductService.AddToCart(selectProduct).subscribe({
//     next:(response) => {
//       console.log('Product added to Cart :', response);

//     },
//     error: (err) => {
//       console.error('Error:', err);
//     }
//   });
// }
  
addToCartApiCall(selectProduct: any) {
  this.addToCartItem=selectProduct;
   console.log("TaddToCartItem ",this.addToCartItem);
   let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token != null || token != undefined){
        this.customerId=localStorage.getItem('customerId')
       
    if(this.customerId!=null && this.customerId!=undefined && this.customerId != 0){
      this.addToCartItem.CustomerId=this.customerId;
      this.addToCartItem.Quantity=selectProduct.Quantity;
      this.addToCartItem.cartStatus='In Cart';
       let originalPrice=  this.selectProduct.productPrice;
       let discountedPrice= Number(originalPrice - (originalPrice * 0.5));
       this.addToCartItem.discountedPrice = String(discountedPrice);
      
      let quan=this.addToCartItem.Quantity;
      this.addToCartItem.discountedPrice=String(discountedPrice*quan);
      this.addToCartItem.productPrice=String(originalPrice*quan);
      console.log('Add to cart item',this.addToCartItem);
       this.cartItems.push(this.addToCartItem);
       console.log('cart Items',this.cartItems)
      this.viewProductService.AddToCart( this.cartItems).subscribe({
        next:(Response)=>{
          
          console.log('Product add to customers cart',Response);
          this.showSuccessModal();
        }
      })
    }
  }
  else{

   this.cart = JSON.parse(localStorage.getItem('cart') || '[]');
  // Check if product already in cart
  const existing = this.cart.find((item: any) => item.productId === selectProduct.productId);
  if (existing) {
    existing.quantity += 1;
  } else {
    this.cart.push({ ...selectProduct,
       quantity: selectProduct.Quantity,
       cartStatus:'In Cart',
       discountedPrice:(selectProduct.productPrice - (selectProduct.productPrice * 0.5))*selectProduct.Quantity,
      
      });
  }
  localStorage.setItem('cart', JSON.stringify(this.cart));
  this.sendCartValue();
    this.showSuccessModal();
}
      
    }

    openSizeChart() {
  // You can add analytics or logging here if needed
  console.log('Size chart modal opened');
}

DeleteFromCartApiCall(selectProduct:any){
   let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token != null || token != undefined){
    if(this.customerId!=null && this.customerId!=undefined && this.customerId != 0 ){
  this.viewProductService.DeleteFromCart(selectProduct.productId).subscribe({
    next:(response) => {
      console.log('Product deleted from Cart :', response);

    },
    error: (err) => {
      console.error('Error:', err);
    }
  });
}
      }
}

  showSuccessModal() {
    const modal = document.getElementById('cartSuccessModal');
    if (modal) {
      modal.classList.add('show');
      modal.style.display = 'block';
      document.body.classList.add('modal-open');
      const modalBackdrop = document.createElement('div');
      modalBackdrop.classList.add('modal-backdrop', 'fade', 'show');
      document.body.appendChild(modalBackdrop);
    }
  }

  closeModal() {
    const modal = document.getElementById('cartSuccessModal');
    if (modal) {
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      const modalBackdrop = document.querySelector('.modal-backdrop');
      if (modalBackdrop) {
        modalBackdrop.remove();
      }
    }
  }

  navigateToCart() {
    this.closeModal();
    this.router.navigate(['/viewCart']);
  }

  continueShopping() {
    this.closeModal();
  window.location.href = '#';
  }
}
